import { h } from 'preact';
import Image from 'utils/image';

const CustomizerIcon = ({ classes, graphicData, openCustomizerStyleModal }) => (
  <button
    className={`${classes} customizer-icon customizer-button body-12-med hover:bg-grey-6 `}
    data-graphic-name={graphicData?.title}
    data-gan={graphicData?.gan}
    data-is-kids-graphic={graphicData?.isKidsGraphic}
    data-is-hoodie-graphic={graphicData?.isHoodieGraphic}
    data-is-tank-graphic={graphicData?.isTankGraphic}
    data-customizer-background-img-url={graphicData?.customizerBackgroundImage}
    onClick={openCustomizerStyleModal}
  >
    <span className="customizer-icon-text">{window.TMW.Strings.product.customize}</span>
    <Image
      src="https://cdn.shopify.com/s/files/1/0686/8326/8417/files/customizer-icon.png?v=1728055689"
      classes="customizer-icon-image w-[12px] block object-fit"
      alt="Customize this product"
      width="12"
      height="12"
    />
  </button>
);

export default CustomizerIcon;
